import { render, staticRenderFns } from "./DistributionDetailsPage.vue?vue&type=template&id=53671b0e&scoped=true"
import script from "./DistributionDetailsPage.vue?vue&type=script&lang=js"
export * from "./DistributionDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./DistributionDetailsPage.vue?vue&type=style&index=0&id=53671b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53671b0e",
  null
  
)

export default component.exports